"use client";

// ONE DOOR ON SCREEN, ALWAYS (2026-10-22).
//
// The homepage hides the header's door (and the ≡, and the you-chip) while the
// hero is up, so the words and netti are the whole composition and the door
// under the headline is the only one. It used to hand over on the ROOM: the
// header's door came back only once the page had moved on to the next room,
// which on /test/home was ~150px after the hero's door had already slid under
// the bar and faded. For that stretch there was no door at all, and the label
// looked as if it faded away as you began to scroll.
//
// Now the hand-over is the hero door itself. While it is visible below the
// header band the root carries `data-hero-door`; the moment it passes under the
// band, the attribute goes and the header's door fades in over the same beat.

import { useEffect, type RefObject } from "react";

/** the header band's height: the hero door counts as gone once it is under it */
const BAND_PX = 96;

export function useHeroDoor(rootRef: RefObject<HTMLElement | null>, selector: string) {
  useEffect(() => {
    const root = rootRef.current;
    const door = root?.querySelector(selector);
    if (!root || !door) return;
    root.setAttribute("data-hero-door", "");
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) root.setAttribute("data-hero-door", "");
        else root.removeAttribute("data-hero-door");
      },
      { rootMargin: `-${BAND_PX}px 0px 0px 0px`, threshold: 0.6 },
    );
    io.observe(door);
    return () => {
      io.disconnect();
      root.removeAttribute("data-hero-door");
    };
  }, [rootRef, selector]);
}
